// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2li0f","errors":"Errors_errors__1JTXU"};